<template>
  <div class="container" style="padding-top: 80px;" v-loading.fullscreen.lock="pageLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <div style="position: fixed; left: 60px; top: 17px; z-index: 10000;">
      <el-button type="info" icon="el-icon-caret-left" size="small" @click="goback">返回</el-button>
    </div>
    <div style="font-size: 18px;">
      <h3 style="margin-left: 5px; color: #555;">編輯<span style="color: #409EFF;">{{ pageName }}</span>共用管理員<mu-icon slot="right" value="account_box" style="margin-left: 20px; transform: scale(2) translateY(1px); color: #666"/></h3>
      <ol style="padding-left: 25px; color: #666;">
        <li style="line-height: 45px;">只有<span style="font-weight: 500; color: black;">主管理員</span>可以編輯共用管理員(目前的主管理員: <span style="color: #409EFF; font-weight: 500;">{{adminName}}</span>)</li>
        <li style="line-height: 45px;">共用管理員必須是<span style="font-weight: 500; color: black;"> EILIS 會員</span></li>
        <li style="line-height: 45px;">如果新增或刪除共用管理員出現錯誤<mu-icon slot="right" value="navigation" style="margin-left: 5px; transform: translateY(6px) rotate(90deg); color: #666; margin-right: 10px;"/>
          <el-button type="primary" @click="redirectRouter('http://draw.re/5ESLG')" target="_blank">聯繫 EILIS 客服</el-button>
        </li>
      </ol>
    </div>
    <el-table height="calc(100vh - 400px)" :empty-text="showText" :data="coadList" style="width: 100%;" :header-cell-style="rowClass" border>
      <el-table-column type="index"
        label="編號"
        width="70">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        width="210">
        <template slot-scope="scope">
          <span><div class="name">{{ scope.row.Name }}</div></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="email"
        label="信箱">
        <template slot-scope="scope">
          <span><div class="tag">{{ scope.row.Email }}</div></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="edit"
        width="220"
        label="操作">
        <template slot-scope="scope">
          <el-button @click="deleteCoad(scope.row)" size="small" type="danger" :disabled="!isAdmin">刪除</el-button>
          <el-button @click="changeAdmin(scope.row)" size="small" type="primary" :disabled="!isAdmin">設為主管理員</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="width: 500px; margin-top: 10px;">
      <el-input :placeholder="hintText" v-model="email" :disabled="!isAdmin">
        <template slot="prepend">新增共用管理員</template>
        <el-button slot="append" type="primary" :disabled="!isAdmin" @click="checkUser">送出</el-button>
      </el-input>
    </div>
    <!-- 確認刪除訊息 -->
    <mu-dialog :open="dblcheck" title="確認訊息" width="550">
      確定要刪除主管理員: <span style="color: #409EFF;">{{ userData.Name }}</span> 嗎?
      <mu-button slot="actions" color="primary" flat @click="dblcheck = false">返回</mu-button>
      <mu-button slot="actions" color="primary" @click="sendDelete">確認</mu-button>
    </mu-dialog>
    <!-- 確認刪除訊息 -->
    <mu-dialog :open="switchcheck" title="確認訊息" width="550">
      確定要將 <span style="color: #409EFF;">{{ userData.Name }}</span> 設為主管理員嗎?
      <mu-button slot="actions" color="primary" flat @click="switchcheck = false">返回</mu-button>
      <mu-button slot="actions" color="primary" @click="confirmSwitch">確認</mu-button>
    </mu-dialog>
    <!-- 確認新增訊息 -->
    <mu-dialog :open="checkSend" title="確認訊息" width="550">
      確定要新增此 EILIS 用戶為 <span style="font-weight: 500; color: #222;">{{ pageName }}</span> 的共同管理員嗎?
      <div style="margin-top: 15px;">
        <mu-avatar color="indigo" style="border: 1px solid;">
          <mu-icon v-if="!coadImg || coadImg === ''" value="account_circle"></mu-icon>
          <img :src="coadImg" v-if="coadImg && coadImg !== ''"/>
        </mu-avatar>
        <div style="color: #409EFF; font-weight: 500; margin-left: 5px; display: inline-block; transform: translateY(-5px);">{{ coadName }}</div>
      </div>
      <mu-button slot="actions" color="primary" flat @click="checkSend = false">返回</mu-button>
      <mu-button slot="actions" color="primary" @click="setCoad">確認</mu-button>
    </mu-dialog>
    <!-- 不是 Eilis 會員 -->
    <mu-dialog :open="notUser" title="系統通知" width="550" @close="notUser = false">
      查無此用戶資料，請確定Email填寫正確
    </mu-dialog>
    <div style="text-align: left; margin-left: -10px; margin-bottom: 20px; margin-top: 15px;">
      <img src="https://i.imgur.com/SITKieL.png" width="120"/>
      <div style="padding-left: 12px; font-size: 13px;">Copyright © 2020 埃立思科技股份有限公司 版權所有</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      pageName: localStorage.getItem('NowPage') ? JSON.parse(localStorage.getItem('NowPage')).PageName : '',
      provider: localStorage.getItem('NowPage') ? JSON.parse(localStorage.getItem('NowPage')).Provider : '',
      service: this.$route.params.service,
      auth: this.$route.params.id,
      pageLoading: false,
      coadList: [],
      showText: '載入中...',
      coadUid: '',
      email: '',
      adminName: '',
      isAdmin: false,
      dblcheck: false,
      switchcheck: false,
      checkSend: false,
      notUser: false,
      coadImg: '',
      coadName: '',
      userData: {}
    };
  },
  mounted() {
    this.getCoadList();
  },
  computed: {
    hintText() {
      return this.isAdmin ? '請輸入Email' : '請主管理員操作';
    }
  },
  methods: {
    ...mapActions({
      deleteCoadmin: 'deleteCoadmin',
      setCoadmin: 'setCoadmin',
      switchAdmin: 'switchAdmin',
      getUserByEmail: 'getUserByEmail',
      getAccountDetail: 'getAccountDetail'
    }),
    showFlassMessage(message, time) {
      this.$notify({
        title: message,
        type: 'success'
      });
    },
    goback() {
      this.$router.push(`/shoplist/?service=${this.service}&auth=${this.auth}`);
    },
    getCoadList() {
      const uid = localStorage.getItem('UserID');
      this.getAccountDetail({ service: this.service, auth: this.auth })
        .then((res) => {
          this.adminName = res.data.Admin;
          this.isAdmin   = (res.data.AdminID === uid) ? true : false;
          if (res.data.Coadmin) {
            this.coadList = res.data.Coadmin;
          }
          else {
            this.coadList = [];
            this.showText = '暫無資料';
          }
        })
    },
    checkUser() {
      this.pageLoading = true;
      this.getUserByEmail({ email: this.email }).then((res) => {
        this.pageLoading = false;
        if (res.data.Email) {
          this.coadUid   = res.data.uid;
          this.coadImg   = res.data.ProfileImg;
          this.coadName  = res.data.UserName;
          this.checkSend = true;
        }
        else {
          this.notUser = true;
        }
      })
    },
    setCoad() {
      this.checkSend   = false;
      this.pageLoading = true;
      this.setCoadmin({ uid: this.coadUid, email: this.email, service: this.service, auth: this.auth, authName: (this.service === 'FB') ? this.pageName : this.provider })
        .then(() => {
          this.showFlassMessage('已新增共用管理員', 1000);
          this.getCoadList();
          this.email       = '';
          this.pageLoading = false;
        })
    },
    sendDelete() {
      this.dblcheck    = false;
      this.pageLoading = true;
      this.deleteCoadmin({ service: this.service, auth: this.auth, uid: this.userData.uid })
        .then(() => {
          this.showFlassMessage('已刪除此管理員', 1000);
          this.getCoadList();
          this.pageLoading = false;
        })
    },
    rowClass({ row, rowIndex }) {
      return 'background-color: #777; color: #fff'
    },
    changeAdmin(user) {
      this.switchcheck = true;
      this.userData = user;
    },
    confirmSwitch() {
      this.switchcheck = false;
      this.pageLoading = true;
      this.switchAdmin({ service: this.service, auth: this.auth, email: this.userData.Email })
        .then(() => {
          this.showFlassMessage('已成功轉移主管理員', 1000);
          this.getCoadList();
          this.pageLoading = false;
        })
    },
    deleteCoad(user) {
      this.dblcheck = true;
      this.userData = user;
    },
    redirectRouter(url) {
      window.open(url);
    },
  },
}
</script>

<style scoped>
  .container {
    text-align: left;
    padding-top: 15px;
    padding-left: 30px;
  }
  .name {
    font-weight: 500;
    font-size: 16px;
    color: #409EFF;
  }
  .tag {
    font-size: 15px;
  }
</style>